import React from 'react';
import PropTypes from 'prop-types';
import { getDestinationImage } from '../../helpers/destination';
import WeekNumber from '../booking-options/BookingOption/components/WeekNumber';
import WeekDate from '../booking-options/BookingOption/components/WeekDate';

const Overview = ({
  week, image = null
}) => {
  // `week.destination` is a full destination object on the destinations endpoint, but only the
  // destination *name* on the yacht-week payload, which carries the photo and the country
  // alongside it as `destinationPhoto` / `destinationCountry`.
  const imageUrl = image && image.url
    || (week && week.destinationPhoto)
    || getDestinationImage(week && week.destination);
  const imageAlt = image && image.alt
    || (week && (week.destinationCountry || (week.destination && week.destination.country)));
  return (
    <div>
      <div className="dui-items-center">
        <div className='dui-hidden md:dui-block dui-relative dui-aspect-[16/9] dui-w-full'>
          <img
            src={imageUrl} alt={imageAlt}
            className="dui-absolute dui-w-full dui-h-full dui-object-cover"
          />
        </div>
        <h3 className='dui-text-2xl dui-mt-4'>{week && week.destination && week.destination.name || week.destination}</h3>
        <p className='dui-mt-4 dui-flex dui-items-center dui-gap-2'>
          <WeekNumber week={week.week}/>
          <span>|</span>
          <WeekDate week={week} />
        </p>
      </div>
    </div>
  );
};

Overview.propTypes = {
  week: PropTypes.object,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string
  })
};

export default Overview;
